export default function BulkDeleteRisksConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  riskDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    const idList = {};
    idList.ids = vm.risks;
    return riskDataService.bulkDeleteRisks(idList)
      .then(() => {
        alerts.success('All risks were successfully deleted.');
        if (vm.updateCallBack) {
          vm.updateCallBack();
        }
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while deleting all risks.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.riskAdmin.bulkDeleteRisksConfirmDialog);
  }
}

BulkDeleteRisksConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'riskDataService',
  'loaderService',
  'ssDialogService'
];
